import { Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType, useCuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { formatNumber, NumberFormatPreset } from '@procureai/ui-mui';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

interface QuantityCellProps<R extends GridValidRowModel = any> {
  value: number;
  unitId: string;
  row: R;
  preset?: NumberFormatPreset;
}

export const QuantityCell = <R extends GridValidRowModel = any>({
  value: quantity,
  unitId,
  preset = NumberFormatPreset.INTEGER,
}: QuantityCellProps<R>) => {
  const { ct } = useCuriosityTranslation(CuriosityNamespaceType.UNIT);

  if (!quantity) {
    return <>{NULLISH_CELL_VALUE}</>;
  }

  const formattedQuantity = preset ? formatNumber(preset, quantity) : quantity;
  const unit = ct(unitId);

  return <Typography>{unit ? `${formattedQuantity} ${unit.value}` : formattedQuantity}</Typography>;
};
